const OBJECT_ID_REGEX = /^[0-9a-fA-F]{24}$/;
const ASSET_ID_FROM_URL_REGEX = /^https?:\/\/[^/]+\/[^/]+\/([0-9a-fA-F]{24})_/;

/**
 * Attempts to recover a 24-character hex string asset ID from a CDN-style URL.
 * Expects a format like: https://[any-host]/[ownerID]/[assetID]_[filename.ext]
 *
 * @param {string} [url] - The URL that may contain a valid asset ID.
 * @returns {string | undefined} The 24-character hex asset ID if found and valid, otherwise undefined.
 */
export function maybeRecoverAssetIdFromUrl(url?: string): string | undefined {
  if (typeof url !== 'string') {
    return;
  }

  const match = url.match(ASSET_ID_FROM_URL_REGEX);
  if (!match) {
    return;
  }

  const candidate = match[1];
  if (candidate && OBJECT_ID_REGEX.test(candidate)) {
    return candidate;
  }

  return;
}
